export default __webpack_public_path__ + "static/media/admin_product_dashboard_active.f268cfd8.svg";